import { useEffect, useState } from 'react';
import { getAdminModules, GetAdminModulesOutputType } from 'zite-endpoints-sdk';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Plus, FileText } from 'lucide-react';

export default function SOPAdminSection() {
  const [sops, setSops] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    getAdminModules({}).then((d: any) => {
      const modules = d.modules || [];
      setSops(modules.filter((m: any) => m.contentType === 'SOP'));
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = sops.filter(s =>
    (s.title || '').toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="space-y-3">{[1,2,3].map(i => <Skeleton key={i} className="h-12" />)}</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-foreground">Standard Operating Procedures</h2>
        <Button size="sm"><Plus className="w-4 h-4 mr-1" /> New SOP</Button>
      </div>

      <div className="flex items-center gap-3 mb-4">
        <div className="relative flex-1 max-w-sm">
          <Search className="w-4 h-4 text-muted-foreground absolute left-2.5 top-1/2 -translate-y-1/2" />
          <Input placeholder="Search SOPs…" value={search} onChange={e => setSearch(e.target.value)} className="pl-9" />
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="text-center py-12 border border-dashed border-border rounded-lg">
          <FileText className="w-10 h-10 text-muted-foreground mx-auto mb-2 opacity-50" />
          <p className="text-sm text-muted-foreground">No SOPs found</p>
          <p className="text-xs text-muted-foreground mt-1">SOPs are modules with content type "SOP" — create one to get started</p>
        </div>
      ) : (
        <div className="space-y-2">
          {filtered.map((s: any) => (
            <div key={s.id} className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg">
              <FileText className="w-5 h-5 text-primary shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="font-medium text-foreground truncate">{s.title}</p>
                <p className="text-xs text-muted-foreground">{s.department || 'All'} · {s.status || 'Draft'}</p>
              </div>
              <span className={`text-xs px-2 py-0.5 rounded ${s.status === 'Published' ? 'bg-primary/10 text-primary' : 'bg-muted text-muted-foreground'}`}>
                {s.status || 'Draft'}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
